import { saveAs } from 'file-saver'

import delay from '@/utils/delay'

import { ApiConfig, AxiosRequestConfig } from '../request'
import post from './get'

interface DownloadApiConfig extends ApiConfig {
  /**
   * 自动保存
   * @default false
   */
  autoSave?: boolean;
}

export default async function download<RESD, REQD> (name: string, data?: REQD, custom?: DownloadApiConfig, config?: AxiosRequestConfig) {
  config = Object.assign({}, config, defaultAxiosConfig)

  const res = await post<RESD, REQD>(name, data, custom, config)

  const fileName = getFileName(res.headers)
  // 转成文件
  const file = new File([res.data as any], fileName)
  const autoSave = custom?.autoSave
  if (autoSave) {
    saveAs(file)
    await delay(1200)
  }

  return {
    ...res,
    data: {
      error_code: 0,
      error_message: '',
      file,
    },
  }
}

const defaultAxiosConfig: AxiosRequestConfig = {
  responseType: 'arraybuffer',
}

/**
 * 获取文件名
 * @param headers 响应头
 */
function getFileName (headers?: any) {
  let fileName = getDisposition(headers?.['content-disposition'])

  if (!fileName) {
    const stamp = Date.now()
    const contentLength = headers?.['content-length'] || '0'
    const extname = getExtname(headers?.['content-type'])
    fileName = stamp + contentLength + extname
  }

  return fileName
}

/**
 * 获取文件扩展名
 * @param contentType 文件类型字符串
 * @returns
 */
function getExtname (contentType?: string) {
  let extName = ''
  if (contentType) {
    extName = contentType.replace(/^.*\/(\w+)$/, '$1')
    if (extName) {
      extName = `.${extName}`
    }
  }

  return extName
}

/**
 * 获取 headers content-disposition
 * @param contentDisposition
 */
function getDisposition (contentDisposition?: string) {
  // 文件名，可能不存在，可能需要nginx开放跨域content-disposition header
  // 格式：attachment;filename="20210114.csv
  if (contentDisposition) {
    return decodeURI(escape(contentDisposition.replace(/.*filename="?(.*\.\w+).*$/, '$1')))
  }

  return ''
}
